import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'context/AuthContext';
import { useGetCurrentSessionUser } from 'hooks/useGetCurrentSessionUser';
import { currentSelectedClientType } from 'features/Client/useSwitchClientList';
import { getNewAccountGroupOtherDetails } from './api';
import { NewAccountGroupOtherDetailsRequest, NewAccountGroupOtherDetailsResponse } from './types';


const transformData = (data: NewAccountGroupOtherDetailsResponse) => {
    return {
        ...data,
        serviceDetails: data?.serviceDetails.map((item: any) => {
            return {
                ...item,
                isActionCompleted: item.isActionCompleted ? "Done" : "Pending",
            }
        })
    }
}

export function useGetNewAccountGroupOtherDetails({ accountNumber }: Omit<NewAccountGroupOtherDetailsRequest, 'subClientId'>) {
    const { user } = useAuth();
    const currentSelectedClient = useGetCurrentSessionUser('currentSelectedClient') as currentSelectedClientType;
    const subClientId = currentSelectedClient?.clientId ?? user?.clientId;

    // QUERY
    const query = useQuery({
        queryKey: ["newAccountGroupOtherDetails", accountNumber],
        queryFn: async () => {
            const { data } = await getNewAccountGroupOtherDetails({ subClientId, accountNumber })
            return transformData(data)
        },
        enabled: !!accountNumber
    });


    return query;
}